// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.PDF = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.PDF = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var PDF = _exports.PDF = function PDF(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 15.6364H5.87891V14.5071H6.4755C7.30824 14.5071 7.82848 14.0135 7.82848 13.2589C7.82848 12.5114 7.31889 12 6.50213 12H5V15.6364ZM5.87891 13.8146V12.7085H6.31214C6.70632 12.7085 6.91761 12.9215 6.91761 13.2589C6.91761 13.5945 6.70632 13.8146 6.31214 13.8146H5.87891Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.60582 15.6364C10.7138 15.6364 11.4009 14.9528 11.4009 13.8164C11.4009 12.6818 10.7138 12 9.60405 12H8.26172V15.6364H9.60582ZM9.14062 14.8871V12.7493H9.55966C10.1847 12.7493 10.5202 13.0334 10.5202 13.8164C10.5202 14.603 10.1847 14.8871 9.57209 14.8871H9.14062Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.9141 15.6364H12.793V14.1751H14.2383V13.4595H12.793V12.7138H14.3963V12H11.9141V15.6364Z",
      fill: "#212B36"
    }));
  };
});
